// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._filterOptions_19m4u_1 {
  /* Typography */
  --pa-filter-item-option-checkbox-font-family-inner: var(
    --pa-filter-item-option-checkbox-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --pa-filter-item-option-checkbox-font-size-inner: var(--pa-filter-item-option-checkbox-font-size, 14px);
  --pa-filter-item-option-checkbox-font-weight-inner: var(
    --pa-filter-item-option-checkbox-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --pa-filter-item-option-checkbox-letter-spacing-inner: var(
    --pa-filter-item-option-checkbox-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --pa-filter-item-option-checkbox-line-height-inner: var(--pa-filter-item-option-checkbox-line-height, 1.2);
  --pa-filter-item-option-checkbox-text-transform-inner: var(
    --pa-filter-item-option-checkbox-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --pa-filter-item-option-checkbox-font-variant-numeric-inner: var(
    --pa-filter-item-option-checkbox-font-variant-numeric,
    var(--perxis-auto-root-typography-main-font-variant-numeric-inner)
  );
  --pa-filter-item-option-group-label-font-family-inner: var(
    --pa-filter-item-option-group-label-font-family,
    var(--perxis-auto-root-typography-small-font-family-inner)
  );
  --pa-filter-item-option-group-label-font-size-inner: var(--pa-filter-item-option-group-label-font-size, 14px);
  --pa-filter-item-option-group-label-font-weight-inner: var(--pa-filter-item-option-group-label-font-weight, 700);
  --pa-filter-item-option-group-label-line-height-inner: var(--pa-filter-item-option-group-label-line-height, 1);
  --pa-filter-item-option-group-label-letter-spacing-inner: var(
    --pa-filter-item-option-group-label-letter-spacing,
    var(--perxis-auto-root-typography-small-letter-spacing-inner)
  );
  --pa-filter-item-option-group-label-text-transform-inner: var(
    --pa-filter-item-option-group-label-text-transform,
    var(--perxis-auto-root-typography-small-text-transform-inner)
  );
  --pa-filter-item-option-group-label-font-variant-numeric-inner: var(
    --pa-filter-item-option-group-label-font-variant-numeric,
    var(--perxis-auto-root-typography-small-font-variant-numeric-inner)
  );
  /* End Typography */
}
._filterOptions__groupLabel_19m4u_46 {
  --perxis-auto-typography-small-font-family: var(--pa-filter-item-option-group-label-font-family-inner);
  --perxis-auto-typography-small-font-weight: var(--pa-filter-item-option-group-label-font-weight-inner);
  --perxis-auto-typography-small-letter-spacing: var(--pa-filter-item-option-group-label-letter-spacing-inner);
  --perxis-auto-typography-small-text-transform: var(--pa-filter-item-option-group-label-text-transform-inner);
  --perxis-auto-typography-small-font-variant-numeric: var(
    --pa-filter-item-option-group-label-font-variant-numeric-inner
  );
  --perxis-auto-typography-small-font-size-xxs: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xs: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-sm: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-md: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-lg: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xl: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-font-size-xxl: var(--pa-filter-item-option-group-label-font-size-inner);
  --perxis-auto-typography-small-line-height-xxs: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xs: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-sm: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-md: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-lg: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xl: var(--pa-filter-item-option-group-label-line-height-inner);
  --perxis-auto-typography-small-line-height-xxl: var(--pa-filter-item-option-group-label-line-height-inner);
}
._filterOptions_19m4u_1 .ant-5_24_1-collapse-header {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
._filterOptions_19m4u_1 .ant-5_24_1-collapse-content-box {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
._filterOptions_19m4u_1 .ant-5_24_1-collapse-item:first-child {
  border-top: var(--perxis-auto-collapse-divider-width-inner) solid var(--perxis-auto-collapse-divider-color-inner);
}
._filterOptions_19m4u_1 .ant-5_24_1-collapse-item:last-child {
  border-bottom: 0;
}
._filterOptions_19m4u_1 .ant-5_24_1-checkbox-group {
  /* Typography */
  --perxis-auto-checkbox-font-family: var(--pa-filter-item-option-checkbox-font-family-inner);
  --perxis-auto-checkbox-font-size: var(--pa-filter-item-option-checkbox-font-size-inner);
  --perxis-auto-checkbox-font-weight: var(--pa-filter-item-option-checkbox-font-weight-inner);
  --perxis-auto-checkbox-letter-spacing: var(--pa-filter-item-option-checkbox-letter-spacing-inner);
  --perxis-auto-checkbox-line-height: var(--pa-filter-item-option-checkbox-line-height-inner);
  --perxis-auto-checkbox-text-transform: var(--pa-filter-item-option-checkbox-text-transform-inner);
  --perxis-auto-checkbox-font-variant-numeric: var(--pa-filter-item-option-checkbox-font-variant-numeric-inner);
  /* End Typography */
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
